"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var PersonalPromoCodeEditor = /** @class */ (function (_super) {
    __extends(PersonalPromoCodeEditor, _super);
    function PersonalPromoCodeEditor(props) {
        return _super.call(this, props) || this;
    }
    PersonalPromoCodeEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AP = this.props.availPromoTpl.Subscribe("*", function (id, data) {
            _this.setState({ avail_promo_template_types: data.data });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    is_locked: _item.is_locked,
                    description: _item.description,
                    title: _item.title,
                    promo_tpl_id: _item.promocode_template_id,
                    promo_tpl_title: _item.promocode_template_title,
                    handling_type_code: _item.handling_type_code,
                    handling_type_title: _item.handling_type_title,
                    avail_promo_template_types: []
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование персонального бонуса"]);
                    _this.props.availPromoTpl.LoadData(_this.state.brand_id);
                });
            }
        }
        else {
            this.setState({
                brand_id: 0,
                brand_title: "",
                is_locked: false,
                description: "",
                title: "",
                promo_tpl_id: 0,
                promo_tpl_title: "",
                handling_type_code: 0,
                handling_type_title: "",
                avail_promo_template_types: []
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание персонального бонуса"]);
            });
        }
        this.doReSetRules();
    };
    PersonalPromoCodeEditor.prototype.componentWillUnmount = function () {
        this.props.availPromoTpl.UnSubscribe(this.SID_AP);
    };
    PersonalPromoCodeEditor.prototype.doReSetRules = function () {
        this.setState({
            brand_rules: { isError: false },
            promo_tpl_rules: { isError: false },
            handling_type_rules: { isError: false },
            title_rules: { isError: false }
        });
    };
    PersonalPromoCodeEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({ brand_rules: { isError: true, errorMessage: "Поле [брэнд] не выбрано!" } });
            return false;
        }
        if ((this.state.promo_tpl_id <= 0) || (this.state.promo_tpl_title.length === 0)) {
            this.setState({ promo_tpl_rules: { isError: true, errorMessage: "Поле [шаблон промокода] не выбрано!" } });
            return false;
        }
        if ((this.state.handling_type_code <= 0) || (this.state.handling_type_title.length === 0)) {
            this.setState({ handling_type_rules: { isError: true, errorMessage: "Поле [тип действия] не выбрано!" } });
            return false;
        }
        if (this.state.title.length <= 0) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено, или заполнено некорректно!" } });
            return false;
        }
        return true;
    };
    PersonalPromoCodeEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                description: this.state.description,
                title: this.state.title,
                is_locked: this.state.is_locked,
                handling_type_code: this.state.handling_type_code
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Персональный бонус изменен!");
            });
        }
    };
    PersonalPromoCodeEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                description: this.state.description,
                promocode_template_id: this.state.promo_tpl_id,
                brand_id: this.state.brand_id,
                is_locked: this.state.is_locked,
                title: this.state.title,
                handling_type_code: this.state.handling_type_code
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Персональный бонус добавлен!");
            });
        }
    };
    PersonalPromoCodeEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PersonalPromoCodeEditor.prototype.getFormTitle = function () {
        if (this.props.record == null) {
            return "Добавить персональный бонус";
        }
        else {
            return "Изменить персональный бонус";
        }
    };
    PersonalPromoCodeEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 500 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false },
                        promo_tpl_id: 0,
                        promo_tpl_title: "",
                        promo_tpl_rules: { isError: false }
                    }, function () {
                        _this.props.availPromoTpl.LoadData(_this.state.brand_id);
                    });
                }, items: this.props.availBrands, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Шаблон промокода:", placeholder: "Выберите шаблон промокода" }, value: { key: this.state.promo_tpl_id, value: this.state.promo_tpl_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        promo_tpl_id: newVal.key,
                        promo_tpl_title: newVal.value,
                        promo_tpl_rules: { isError: false }
                    });
                }, items: this.state.avail_promo_template_types, disabled: this.props.record != null, required: true, rules: this.state.promo_tpl_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип обработчика:", placeholder: "Выберите тип обработчика" }, value: { key: this.state.handling_type_code, value: this.state.handling_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        handling_type_code: newVal.key,
                        handling_type_title: newVal.value,
                        handling_type_rules: { isError: false }
                    });
                }, items: this.props.availHandlingTypes, required: true, rules: this.state.handling_type_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Персональный бонус заблокирован", value: this.state.is_locked, onChecked: function (checked) {
                    _this.setState({
                        is_locked: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return PersonalPromoCodeEditor;
}(React.Component));
exports.default = PersonalPromoCodeEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_personal/ui/component/PersonalPromoCodeEditor.tsx
// module id = 2582
// module chunks = 0